<template>
  <h5 style="padding-left: 14px;color: black;font-weight: bolder;">
      <span>{{ $t("subTitle") }}</span>
      <!-- <a class="bd-url" style="position: relative;left: 10px;text-decoration: underline;" :href="getUrl()">{{ $t("moreText") }}</a> -->
      <a class="bd-url" style="position: relative;left: 10px;text-decoration: underline;" @click="goToInputLink()">{{ $t("moreText") }}</a>
  </h5>
</template>

<script>
export default {
  methods:{
    goToInputLink() {
      window.location.href = this.getUrl();
    },
    getUrl(){
      return this.$t('url')
    }
  }
}
</script>

<style>

</style>
<i18n src="@/locales/actions.locale"></i18n>

<i18n src="@/locales/registration.locale"></i18n>

<i18n src="@/locales/login.locale"></i18n>

<i18n>
{
  "en": {
    "subTitle": "Signing of Documents is only available for \"iAM Smart+\" (with digital signing function) or \"Digital Certificate\" users",
    "moreText": "(More lnfo)",
    "url":"https://www.iamsmart.gov.hk/en/about-version.html"
  },
  "zh_hk": {
    "subTitle": "簽署文件只適用於「智方便+」(具有數碼簽署功能) 或「數碼證書」的用戶",
    "moreText": "(了解更多)",
    "url":"https://www.iamsmart.gov.hk/tc/about-version.html"
  },
  "zh_cn": {
    "subTitle": "签署文件只适用于「智方便+」(具有数码签署功能) 或「数码证书」的用户",
    "moreText": "(了解更多)",
    "url":"https://www.iamsmart.gov.hk/sc/about-version.html"
  }
}
</i18n>